import React, { useState, useRef, useEffect } from "react";
import { indeeAuth } from "../../utils/api/helpers/indee";
import { Modal } from "../../utils/Ui/Modal";
import {
  useDisplayScreenerLogin,
  setDisplayScreenerLogin,
  setDisplayScreenerProjectList,
  useAuthActionFlag,
  setAuthActionFlag,
  useAuthComplete,
  setAuthComplete,
  useSuccess,
  setSuccess,
} from "../../utils/Screeners/useScreeners";

export const ScreenerLogin = () => {
  const [pin, setPin] = useState("");

  const inputRef = useRef();

  const displayScreenerLogin = useDisplayScreenerLogin();
  const authActionFlag = useAuthActionFlag();
  const authComplete = useAuthComplete();
  const success = useSuccess();

  useEffect(() => {
    clearForm();
  }, []);

  const clearForm = () => {
    setPin("");
    setSuccess(false);
    setAuthComplete(false);
    setAuthActionFlag(false);
    if (inputRef.current) {
      inputRef.current.value = "";
    }
  };

  const authorize = () => {
    indeeAuth(pin).then((result) => {
      // console.log("indeeAuth", result);
      let successful = !(
        (result.data.error && result.data.message.unauth) ||
        result.data.status_code === "W2002"
      );
      setSuccess(successful);
      setAuthComplete(true);
      setAuthActionFlag(!authActionFlag);
      if (successful) {
        setDisplayScreenerProjectList(true);
        setDisplayScreenerLogin(false);
      }
    });
  };

  return (
    <Modal
      scrollable={false}
      isOpen={displayScreenerLogin}
      onClose={() => {
        clearForm();
        setDisplayScreenerLogin(false);
      }}
      title="Screener Login"
      size="quarter"
    >
      <>
        <div className={"my-4 pb-2"}>
          <div className={"d-flex align-items-center justify-content-center"}>
            <div
              className={
                "d-flex align-items-center justify-content-center pe-3"
              }
            >
              <img
                src={"/img/netflix-logo-ribbon.png"}
                className="header__logo"
                alt="Netflix"
                style={{ maxWidth: "15px" }}
              />
            </div>
            <div className={"d-flex align-items-center justify-content-center"}>
              <span
                className={""}
                style={{
                  fontSize: "14px",
                  fontWeight: "300",
                  color: "#aaa",
                }}
              >
                FYC
              </span>
            </div>
          </div>
        </div>
        <div className={"h4 text-white fw-light text-center"}>
          {!authComplete
            ? "Enter Your Screener Code"
            : success
              ? "Success!"
              : "Unauthorized"}
        </div>
        <div className={"p mb-4 pb-2 text-center"}>
          {!authComplete
            ? "Enter the code you received to access your FYC Screener Content."
            : success
              ? "Click below to continue. You may access screeners at any time by clicking\n" +
                '                                    "Watch Now" on any title page.'
              : "There was an issue with the code you entered. Please try again."}
        </div>

        {!authComplete && !success ? (
          <div className="pin-input mb-4">
            <label htmlFor="indee-pin" className="visually-hidden">
              Pin
            </label>

            <input
              id="indee-pin"
              autoComplete="one-time-code"
              value={pin}
              ref={inputRef}
              onChange={(e) => setPin(e.target.value)}
              placeholder="Code"
              className="indee-pin-input"
            />
          </div>
        ) : null}

        <div className={"d-flex justify-content-center"}>
          {!authComplete && !success ? (
            <button className={"button button-red"} onClick={() => authorize()}>
              {"SUBMIT"}
            </button>
          ) : null}
          {authComplete && !success ? (
            <button
              onClick={() => {
                setAuthComplete(false);
                setPin("");
              }}
            >
              {"ENTER NEW CODE"}
            </button>
          ) : null}
          {authComplete && success ? (
            <button
              onClick={() => {
                setDisplayScreenerLogin(false);
                setDisplayScreenerProjectList(true);
              }}
            >
              Watch Now
            </button>
          ) : null}
        </div>
        <div
          className={
            "d-flex justify-content-center text-uppercase text-white mt-5 mb-3"
          }
          style={{
            fontSize: ".75rem",
            letterSpacing: ".15em",
            opacity: 0.65,
          }}
        >
          Other Ways to Watch
        </div>
        <div
          className={
            "d-flex justify-content-center ways-to-watch-container mb-4"
          }
          style={{ gap: "1rem" }}
        >
          <div className={"ways-to-watch-item"}>
            <a
              href={
                "https://apps.apple.com/us/app/netflix-awards/id6469587713?platform=appleTV"
              }
              target={"_blank"}
              rel={"noopener noreferrer"}
            >
              <img
                src={"/img/ico/icon-appletv.png"}
                alt={"Apple TV"}
                style={{ width: 30 }}
              />
            </a>
          </div>
          <div className={"ways-to-watch-item"}>
            <a
              href={"https://apps.apple.com/us/app/netflix-awards/id6469587713"}
              target={"_blank"}
              rel={"noopener noreferrer"}
            >
              <img
                src={"/img/ico/icon-ios.png"}
                alt={"IOS"}
                style={{ width: 30 }}
              />
            </a>
          </div>
          <div className={"ways-to-watch-item"}>
            <a
              href={
                "https://channelstore.roku.com/details/58fb9712c1dc2e92346f02e77ab90ea0/netflix-awards"
              }
              target={"_blank"}
              rel={"noopener noreferrer"}
            >
              <img
                src={"/img/ico/icon-roku.png"}
                alt={"Roku"}
                style={{ width: 40 }}
              />
            </a>
          </div>
          <div className={"ways-to-watch-item"}>
            <a
              href={"https://www.amazon.com/gp/product/B0CL9FW826"}
              target={"_blank"}
              rel={"noopener noreferrer"}
            >
              <img
                src={"/img/ico/icon-amazonfire.png"}
                alt={"Amazon Fire"}
                style={{ width: 54 }}
              />
            </a>
          </div>
        </div>
      </>
    </Modal>
  );
};
